import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { AuthenticationService } from '../authentication.service';
import {
  TableResponse,
  TableRequest,
  TableDataProvider,
} from '../../components/table/table.interface';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TableApiService implements TableDataProvider {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = environment.apiBaseUrl;
  authService = inject(AuthenticationService);
  endpoint = '';

  initialize(endpoint: string): void {
    this.endpoint = endpoint;
  }

  fetchData(params: TableRequest): Observable<TableResponse> {
    const requestBody = this.buildRequestBody(params);
    return this.http.post<TableResponse>(this.baseUrl + this.endpoint, requestBody);
  }

  /**
   * Builds the request body, optionally excluding filter-related fields.
   */
  private buildRequestBody(params: TableRequest): Partial<TableRequest> {
    const { skipFilters, ...rest } = params;

    if (skipFilters) {
      // Remove filter-related properties for endpoints that don't support them
      const { filters, getAvailableFilters, ...cleanParams } = rest;
      return cleanParams;
    }

    return rest;
  }
}
